export default __webpack_public_path__ + "static/media/RentedBooks.956221c1.svg";